'use client';

import dynamic from 'next/dynamic';
import ReactLoadingSkeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Hao = dynamic(() => import('@fe-news/components/NewsDetail/Hao'), { ssr: false });
const Comment = dynamic(() => import('@fe-news/components/NewsDetail/Comment'), { ssr: false });

export const CryptoPromotion = dynamic(() => import('@fe-news/components/NewsDetail/CryptoPromotion'), {
  loading: () => null
});

export const DynamicAd = dynamic(() => import('@fe-news/components/DynamicAd/DynamicAd'), {
  loading: () => null,
  ssr: false
});

export const DynamicReadMore = dynamic(() => import('@fe-news/components/NewsDetail/ReadMore'), {
  ssr: false,
  loading: () => <ReactLoadingSkeleton height={190} />
});

export const DynamicLoadHaoAndComment = ({
  id,
  categoryId = 0,
  isBcNews = false
}: {
  id: number;
  categoryId?: number;
  isBcNews?: boolean;
}) => {
  return (
    <>
      <Hao categoryId={categoryId} isBcNews={isBcNews} />
      <Comment newsId={id} />
    </>
  );
};
